import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { extendObservable } from 'mobx'
import styled, { keyframes } from 'styled-components'
import PlayItemUnresolved from '@/Components/CommandHost/PlayItemUnresolved'
import { vhToPx } from '@/utils'
import { responsiveDimension } from '../../utils'

@inject('PrePlayStore', 'PlayStore', 'GameStore')
@observer
export default class UnresolvedPanel extends Component {
  constructor(props) {
    super(props)
  }

  handleResolvePending(args) {
    this.props.GameStore.resolvePlay(args)
  }

  handleGamesUpdate(item) {
    this.props.GameStore.updatePlay(item)
  }

  render() {
    const items = this.props.PrePlayStore.unresolvedItems.sort(
      (a, b) => new Date(b.started) - new Date(a.started)
    )

    return (
      <UnResolvedContainer
        id="un_resolved_container_play_stacks"
        len={(items || []).length}
      >
        <TitleContainer>{'TO RESOLVE'}</TitleContainer>
        {items.map(item => {
          return (
            <PlayItemUnresolved
              //key={item.index}
              key={`unresolved-play-${item.id}`}
              item={item}
              resolvePending={this.handleResolvePending.bind(this)}
              gamesUpdate={this.handleGamesUpdate.bind(this)}
            />
          )
        })}
        {/* //split attempt
                    this.props.PrePlayStore.unresolvedItemsBuffer.length ?
                      (setTimeout(() => this.props.PrePlayStore.setUnresolvedItems(), 1000
                      )) :
                      (
                        null
                      )
                      */}
      </UnResolvedContainer>
    )
  }
}

const UnResolvedContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #eaeaea;
  position: relative;
  z-index: 0;
  padding-right: 0.6%;
  margin-bottom: ${props => (!props.len ? responsiveDimension(1) : '')};
`

const TitleContainer = styled.div`
  width: 100%;
  height: ${responsiveDimension(2.6)};
  display: flex;
  justify-content: center;
  font-family: pamainbold;
  font-size: ${responsiveDimension(2)};
  color: #808285;
  letter-spacing: 2px;
  transform: scaleX(1.5);
`



// WEBPACK FOOTER //
// src/Components/CommandHost/UnresolvedPanel.js